<template>
  <div>
    <loader v-if="loggingIn" />
    <div v-show="showMenu">
      <div class="header-bg" v-if="!hideNameAndMenu"></div>
      <div class="header" v-if="!hideNameAndMenu">
        <div class="elitefit_logo mt-1 color-primary" @click="goToHomePage">
          EliteFit.AI <sub>Beta</sub>
        </div>
        <div class="tenant-dropdown">
          <div class="mt-1" v-show="showTenantList && tenantList && shouldLoadTenantList
            ">
            <b-form-group label="Tenant Name" label-class="tenant__label text-light" label-cols="5">
              <multiselect v-model="tenantValue" :options="tenantList" placeholder="Select one" label="name"
                class="bg-white" :deselect-label="''">
              </multiselect>
            </b-form-group>
          </div>
        </div>
        <div class="close_icon mt-1" v-if="showClose" @click="goToHomePage">
          <img height="20" width="20" src="../assets/close-icon.svg" />
        </div>
        <div class="burger-menu col-1 text-right p-0 mt-1" v-else name="burgerIcon">
          <img class="burger-menu-icon" name="burgerIcon" height="40" width="30" src="../assets/menu-icon.svg"
            @click="showBurgerMenu" />
        </div>
        <!--Notice Message-->
        <div class="noticeContainer" v-if="getIosVersion < 11">
          <img class="versionCheckImg" src="../module_user/assets/images/versioncheck.svg" />
          <div class="notice">
            For a better user experience, please upgrade to iOS 15 or a later
            version.
          </div>
        </div>
        <!--End Notice Message -->

        <!-- WARNING BAND FOR STAGING WEBSITE -->
        <!-- <div class="stagingContainer">
        <div class="staging-warning" v-if="!isProd && isShown">
          This is a test site for internal use only. Please visit <a class="site-link-text" href="https://www.elitefit.ai">www.elitefit.ai</a>.
          <a class="dismiss-text" v-on:click="toggleIsShown()">Click to dismiss.</a>
        </div>
        </div> -->
        <!-- WARNING BAND FOR STAGING WEBSITE -->


      </div>
      <transition name="slide-fade">
        <div class="col-4 col-sm-2 col-xs-2 p-0 burger-menu-container" v-if="burgerMenu">
          <div class="burger-menu-items font-white-20">
            <div class="menu-item menu-close mb-3">
              <span @click="hideBurgerMenu"><img height="12" width="12" src="../assets/close-icon.svg" /></span>
            </div>
            <div class="menu-item" @click="goToHomePage">HOME</div>
            <div class="menu-item text-uppercase" @click="goToCorporatePage" v-if="userInfo && userInfo.corporate">
              {{ userInfo.corporate.organization }}
            </div>
            <div class="menu-item" @click="gotoAllVideos">ALL WORKOUTS</div>
            <div class="menu-item" @click="goToFaq">FAQ</div>

            <div v-if="!anonymous">
              <div class="menu-item" @click="gotoProfile">PROFILE</div>
              <div v-if="isAdmin" class="menu-item" @click="goToAdminProfile">
                ADMIN PROFILE
              </div>
            </div>
            <div v-if="!anonymous" class="menu-item" @click="signOut">
              SIGN OUT
            </div>
            <div v-if="anonymous" class="menu-item" @click="signIn">SIGN IN</div>
            <div class="border-top-grn"></div>
            <div class="menu-item" @click="gotoAboutUs">OUR JOURNEY</div>
            <div class="menu-item" @click="gotoCareer">CAREERS</div>
          </div>

          <div class="burger-menu-sign-up" v-show="anonymous">
            <!-- on click of div go to sign up page -->
            <div>
              <span class="font-white-15 burger-sign-up-with"> SIGN UP WITH</span>
              <div class="w-100 mt-2 sign-in-icons">
                <span class="custom-button button-icons custom-button-greyed facebook-button-group"
                  style="background: grey">
                  <p class="facebook-button-group">
                    <img id="facebook" src="../module_user/assets/images/fb.svg" alt srcset />
                  </p>
                </span>
                <span class="custom-button button-icons header-signin-g">
                  <google-sso> </google-sso>
                </span>
                <span style="" class="custom-button button-icons" @click="signUpMail">
                  <p>
                    <img src="../module_user/assets/images/envelope.svg" alt srcset />
                  </p>
                </span>
              </div>

              <div>
                <div class="font-white-15 sign-up-to-parent mt-2">
                  <p class="sign-up-to">SIGN UP TO</p>
                  <div class="">
                    <div class="mt-3 sign-up-item-div">
                      <img src="../module_user/assets/images/newcontent.svg" alt srcset class="icon-img" /><span
                        class="font-white-15 sign_up-item">Get new content</span>
                    </div>
                    <div class="mt-3 sign-up-item-div">
                      <img src="../module_user/assets/images/track.svg" alt srcset class="icon-img" /><span
                        class="font-white-15 sign_up-item">Track your progress
                      </span>
                    </div>
                    <div class="mt-3 sign-up-item-div">
                      <img src="../module_user/assets/images/share.svg" alt srcset class="icon-img" /><span
                        class="font-white-15 sign_up-item">Share your workouts</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>


import Multiselect from 'vue-multiselect'
import { mapMutations, mapState, mapGetters, mapActions } from "vuex";
import GoogleSso from "@/components/GoogleSso";
import { createNamespacedHelpers } from "vuex";
import gtag from "@/module_user/mixins/gtag";
import LineChart from '@/module_user/components/LineChart.vue';
const { mapState: workoutState } = createNamespacedHelpers("user/workout");
export default {
  data: function () {
    return {
      privileges: null,
      showTenantList: false,
      isShown: true,
      tenantValue: null
    };
  },
  watch: {
    tenantValue(value) {
      this.setSelectedTenant(value.id);
    }
  },
  props: {
    hideNameAndMenu: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Multiselect,
    GoogleSso,
  },
  mixins: [gtag],
  computed: {
    ...mapState([
      "showClose",
      "burgerMenu",
      "userInfo",
      "tenantList",
      "selectedTenant",
      "loggingIn",
    ]),
    ...mapGetters(["isAdmin"]),
    ...workoutState(["isVideoPlaying", "mouseHover", "userWorkout"]),
    anonymous() {
      if (this.$store.state.userInfo) {
        return this.$store.state.userInfo.isAnonymousUser;
      } else {
        return true;
      }
    },
    currentRouteName() {
      return this.$route.name;
    },
    shouldLoadTenantList() {
      return (this.currentRouteName == 'dashboard' ||
        this.currentRouteName == 'users' ||
        this.currentRouteName == 'end-users' ||
        this.currentRouteName == 'videos' ||
        this.currentRouteName == 'historylist' ||
        this.currentRouteName == 'Trainer Dashboard' ||
        this.currentRouteName == 'Trainer Videos' ||
        this.currentRouteName == 'Trainer Edit' ||
        this.currentRouteName == 'test-report' ||
        this.currentRouteName == 'all-videos'
      )
    },

    getIosVersion() {
      let ua = navigator.userAgent;
      let userOS = "";
      let uaindex = "";
      let userOSver = "";
      if (ua.match(/iPad/i) || ua.match(/iPhone/i)) {
        userOS = "iOS";
        uaindex = ua.indexOf("OS");
      }
      if (userOS === "iOS" && uaindex > -1) {
        userOSver = ua.substr(uaindex + 3, 3).replace("_", ".");
        return userOSver;
      }
    },
    showMenu() {
      if (this.currentRouteName == "workout") {
        return !this.isVideoPlaying || this.mouseHover || !this.userWorkout;
      }
      return true;
    },
    tenant: {
      get() {
        return this.selectedTenant;
      },
      set(newValue) {
        this.setSelectedTenant(newValue);
      },
    },

    isProd() {
      return [
        'elitefitforyou.com',
        'www.elitefitforyou.com',
        'elitefit.ai',
        'wwww.elitefit.ai',
      ].includes(location.hostname)
    }
  },
  methods: {
    ...mapMutations(["setCloseOnHeader", "openBurgerMenu", "closeBurgerMenu"]),
    ...mapActions(["loadAllTenants", "setSelectedTenant"]),
    showBurgerMenu() {
      this.openBurgerMenu();
    },

    toggleIsShown() {
      this.isShown = false;
    },

    hideBurgerMenu() {
      this.closeBurgerMenu();
    },
    hideBurgerMenuOnOutsideClick(event) {
      if (event.target.id == "signIcons") {
        return;
      }
      if (event.target.id == 'facebook' || event.target.classList.contains('facebook-button-group')) {
        return;
      }
      if (event.target.name !== "burgerIcon") {
        this.closeBurgerMenu();
      }
    },
    navigateToAdminSection() {
      this.$router.push("/admin/trainer-profile");
    },
    signIn() {
      this.trackButtonClick("SignIn");
      this.hideBurgerMenu();
      this.$router.push("/ef/sign-in");
    },
    signOut() {
      this.trackButtonClick("SignOut");
      this.$store.dispatch("logout");
    },
    signUpMail() {
      this.hideBurgerMenu();
      this.$router.push("/ef/sign-up");
    },
    goToHomePage() {
      if (this.userInfo.corporate != null) {
        if (this.userInfo.corporate.redirect_url != null) {
          let redirect_url = this.userInfo.corporate.redirect_url;
          this.$router.push({ path: `/${redirect_url}` });
        }
      } else if (this.userInfo.role == "Admin" || this.userInfo.role == "Trainer") {
        this.$router.push({ name: `Trainer Profile` });
      } else if (this.userInfo.role == 'Enduser' && !this.userInfo.isAnonymousUser) {
        this.$router.push({ name: "User Progress" });
      }
      else if (this.userInfo.role == 'Super Admin') {
        this.$router.push({path: `/admin/dashboard`});
      } else if (this.userInfo.isAnonymousUser) {
        this.$router.push({ path: "/home" })
      } else {
        this.$router.push({path: `/user/main`});
      }
      this.setCloseOnHeader(false);
    },
    gotoProfile() {
      this.hideBurgerMenu();
      this.$router.push("/user-profile/progress");
      this.setCloseOnHeader(false);
    },
    goToAdminProfile() {
      this.hideBurgerMenu();
      this.$router.push("/admin/dashboard");
      this.setCloseOnHeader(false);
    },
    gotoAboutUs() {
      this.hideBurgerMenu();
      this.$router.push("/our-journey");
      this.setCloseOnHeader(false);
    },
    gotoCareer() {
      this.hideBurgerMenu();
      this.$router.push("/careers");
      this.setCloseOnHeader(false);
    },
    gotoAllVideos() {
      this.hideBurgerMenu();
      this.$router.push("/user/discover");
      this.setCloseOnHeader(false);
    },
    goToFaq() {
      this.trackButtonClick("Goto FAQ");
      this.hideBurgerMenu();
      this.$router.push("/faqs");
      this.setCloseOnHeader(false);
    },
    goToCorporatePage() {
      if (this.userInfo.corporate) {
        this.$router.push(`/${this.userInfo.corporate.redirect_url}`);
      }
    },
  },

  async created() {
    this.privileges = this.userInfo.privileges;
    if (this.privileges.includes("access-all-tenants") && this.shouldLoadTenantList) {
      if (!this.tenantList.length) await this.loadAllTenants();
      this.tenantValue = this.selectedTenant ? this.tenantList.find(val => val.id === this.selectedTenant) : this.tenantList[0];
      this.showTenantList = true;
    }
    window.addEventListener("click", this.hideBurgerMenuOnOutsideClick);
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.stagingContainer {
  display: flex;
  justify-content: center;
  width: 100%;
  position: absolute;
}

.noticeContainer {
  width: 100%;
  height: 100vh;
  background-color: black;
  position: absolute;
  display: flex;
  align-items: center;
  text-align: left;
  padding: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.notice {
  width: 90%;
  font-family: Kanit-SemiBold, Kanit;
  font-weight: 600;
  font-size: 30px;
  text-align: center;
  padding-top: 20px;
}

.versionCheckImg {
  width: 120px;
}

.facebook-button-group {
  cursor: auto;
}

.header-bg {
  background-image: linear-gradient(to bottom, #a7a9ac, #fff);
  opacity: 0.1;
  mix-blend-mode: multiply;
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 35px;
}

.header {
  position: fixed;
  z-index: 9999;
  width: 100%;
  left: 0;
  font-family: Kanit-Regular, Kanit;
}

.elitefit_logo {
  color: #fff;
  font-size: 20px;
  font-family: Kanit-SemiBold, Kanit;
  font-weight: 600;
  position: absolute;
  margin-left: 10px;
  cursor: pointer;
}

.close_icon {
  position: absolute;
  top: 3%;
  right: 1%;
  z-index: 5;
  cursor: pointer;
}

.burger-menu {
  position: absolute;
  top: 3%;
  right: 1%;
  z-index: 5;
  // cursor: pointer;
}

.burger-menu-icon {
  cursor: pointer;
}

.sign-up-to-parent {
  padding: 22px;
  text-align: center;
}

.sign-in-icons {
  display: flex;
  align-items: center;
  justify-content: center;
}

.burger-menu-container {
  position: fixed;
  right: 0%;
  top: 0%;
  width: 190px;
  height: 100%;
  opacity: 0.9;
  z-index: 9999;
  overflow: auto;
  background: #f3f3f3f0;

  .burger-menu-items {
    padding-bottom: 15px;
    background: #ffffff;
    color: #000000b3;
  }

  .burger-menu-sign-up {
    // cursor: pointer;
    min-height: 100%;
    height: auto;
    background: #231f20;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .menu-item {
    font-size: 15px;
    height: 30px;
    text-align: center;
    padding: 3%;
    cursor: pointer;
  }

  .menu-close {
    pointer-events: auto;
    cursor: pointer;
    text-align: right;
    padding-right: 15%;
  }

  .sign_up-item {
    display: block;
  }

  .button-icons {
    width: 35px;
    background: #73bc44;
    float: left;
    height: 25px;
    margin: 0 5px;

    img {
      vertical-align: initial;
      height: 16px;
    }
  }
}

.tenant-dropdown {
  width: 400px;
  max-width: 50%;
  float: right;
  margin-right: 10%;
}

sub {
  font-style: italic;
}

.skew-left {
  transform: skewX(25deg);
  height: 15px;
  width: 15px;
}

.border-top-grn {
  border-top: 1px solid #73bc44;
  margin: 5px 20px;
}

.burger-icon-img {
  height: 40px !important;
  width: 30px !important;
}

.slide-fade-enter-active {
  transition: all .2s ease;
}

.dismiss-text {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.slide-fade-leave-active {
  transition: all .2s ease;
}

.staging-warning {
  padding: 8px 10px;
  color: black;
  background-color: #73bc44;
  width: fit-content;
  margin: auto;
  font-size: 18px;
}

.site-link-text {
  color: #fff;
}

.dismiss-text {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

.slide-fade-enter,
.slide-fade-leave-to

/* .slide-fade-leave-active below version 2.1.8 */
  {
  transform: translate(100%, 0);

}

@media screen and (max-width: 900px) {
  .noticeContainer {
    padding: 2%;
  }

  .staging-warning {
    padding: 2px 4px !important;
    font-size: 11px !important;
  }

  .sign-in-icons {
    width: 58% !important;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
}

@media screen and (max-width: 1024px) {
  .staging-warning {
    padding: 4px 8px;
    color: black;
    background-color: #73bc44;
    width: fit-content;
    margin: auto;
    font-size: 15px;
  }

  .notice {
    width: 90%;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  .notice {
    font-size: 25px;
    width: 76%;
    margin-right: 2vw;
  }
}
</style>
